export function getFullName(firstName, lastName) {
  return `${firstName} ${lastName}`;
}

export function getInitials(firstName, lastName) {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`;
}
